import {Strand} from 'constants/MolbioConstants';

import {AnnotationPanelEditData} from './reduceFeaturePanelUI';

export enum FeaturePanelUIActionType {
  CLOSE_SEQUENCE = 'CLOSE_SEQUENCE',
  CHANGE_SELECTION_RANGE = 'CHANGE_SELECTION_RANGE',
  SELECT_ANNOTATION = 'SELECT_ANNOTATION',
  UPDATE_ANNOTATION_EDIT_DATA = 'UPDATE_ANNOTATION_EDIT_DATA',
  OPEN_CREATE_NEW_ANNOTATION = 'OPEN_CREATE_NEW_ANNOTATION',
  CANCEL_CREATE_NEW_ANNOTATION = 'CANCEL_CREATE_NEW_ANNOTATION',
  FOCUS_ANNOTATION_FORM_COMPLETE = 'FOCUS_ANNOTATION_FORM_COMPLETE',
  OPEN_CREATE_NEW_TRANSLATION = 'OPEN_CREATE_NEW_TRANSLATION',
  CANCEL_CREATE_NEW_TRANSLATION = 'CANCEL_CREATE_NEW_TRANSLATION',
}

interface CloseSequenceAction {
  type: FeaturePanelUIActionType.CLOSE_SEQUENCE;
  sequenceId: string;
}
export function closeSequence(sequenceId: string): CloseSequenceAction {
  return {
    type: FeaturePanelUIActionType.CLOSE_SEQUENCE,
    sequenceId,
  };
}

interface ChangeSelectionRangeAction {
  type: FeaturePanelUIActionType.CHANGE_SELECTION_RANGE;
  sequenceId: string;
  start: number | null;
  end: number | null;
}
export function changeSelectionRegion(
  sequenceId: string,
  start: number | null,
  end: number | null
): ChangeSelectionRangeAction {
  return {
    type: FeaturePanelUIActionType.CHANGE_SELECTION_RANGE,
    sequenceId,
    start,
    end,
  };
}

interface SelectAnnotationAction {
  type: FeaturePanelUIActionType.SELECT_ANNOTATION;
  sequenceId: string;
  data: AnnotationPanelEditData;
}
export function selectAnnotation(sequenceId: string, data: AnnotationPanelEditData): SelectAnnotationAction {
  return {
    type: FeaturePanelUIActionType.SELECT_ANNOTATION,
    sequenceId,
    data,
  };
}

interface UpdateAnnotationEditDataAction {
  type: FeaturePanelUIActionType.UPDATE_ANNOTATION_EDIT_DATA;
  sequenceId: string;
  data: Partial<AnnotationPanelEditData>;
}
export function updateAnnotationEditData(
  sequenceId: string,
  data: Partial<AnnotationPanelEditData>
): UpdateAnnotationEditDataAction {
  return {
    type: FeaturePanelUIActionType.UPDATE_ANNOTATION_EDIT_DATA,
    sequenceId,
    data,
  };
}

interface OpenCreateNewAnnotationAction {
  type: FeaturePanelUIActionType.OPEN_CREATE_NEW_ANNOTATION;
  sequenceId: string;
}
export function openCreateNewAnnotation(sequenceId: string): OpenCreateNewAnnotationAction {
  return {
    type: FeaturePanelUIActionType.OPEN_CREATE_NEW_ANNOTATION,
    sequenceId,
  };
}

interface CancelCreateNewAnnotationAction {
  type: FeaturePanelUIActionType.CANCEL_CREATE_NEW_ANNOTATION;
  sequenceId: string;
}
export function cancelCreateNewAnnotation(sequenceId: string): CancelCreateNewAnnotationAction {
  return {
    type: FeaturePanelUIActionType.CANCEL_CREATE_NEW_ANNOTATION,
    sequenceId,
  };
}

interface FocusAnnotationFormCompleteAction {
  type: FeaturePanelUIActionType.FOCUS_ANNOTATION_FORM_COMPLETE;
  sequenceId: string;
}
export function focusAnnotationFormComplete(sequenceId: string): FocusAnnotationFormCompleteAction {
  return {
    type: FeaturePanelUIActionType.FOCUS_ANNOTATION_FORM_COMPLETE,
    sequenceId,
  };
}

interface OpenCreateNewTranslationAction {
  type: FeaturePanelUIActionType.OPEN_CREATE_NEW_TRANSLATION;
  sequenceId: string;
  strand: Strand;
}
export function openCreateNewTranslation(
  sequenceId: string,
  strand?: Strand
): OpenCreateNewTranslationAction {
  return {
    type: FeaturePanelUIActionType.OPEN_CREATE_NEW_TRANSLATION,
    sequenceId,
    strand: strand ?? 1,
  };
}

interface CancelCreateNewTranslationAction {
  type: FeaturePanelUIActionType.CANCEL_CREATE_NEW_TRANSLATION;
  sequenceId: string;
}
export function cancelCreateNewTranslation(sequenceId: string): CancelCreateNewTranslationAction {
  return {
    type: FeaturePanelUIActionType.CANCEL_CREATE_NEW_TRANSLATION,
    sequenceId,
  };
}

export type FeaturePanelUIAction =
  | CloseSequenceAction
  | ChangeSelectionRangeAction
  | SelectAnnotationAction
  | UpdateAnnotationEditDataAction
  | OpenCreateNewAnnotationAction
  | CancelCreateNewAnnotationAction
  | FocusAnnotationFormCompleteAction
  | OpenCreateNewTranslationAction
  | CancelCreateNewTranslationAction;
